/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playbar_VolumeInputs */

const en_playbar_volume = /** @type {(inputs: Playbar_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume`)
};

const es_playbar_volume = /** @type {(inputs: Playbar_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volumen`)
};

/**
* | output |
* | --- |
* | "Volume" |
*
* @param {Playbar_VolumeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const playbar_volume = /** @type {((inputs?: Playbar_VolumeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playbar_VolumeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_playbar_volume(inputs)
	return en_playbar_volume(inputs)
});